export default __webpack_public_path__ + "static/Small-Business_Leader-2089053078aff9509fe9166462150fef.svg";